/*! Cazotti clothing bundles auto-apply BUNDLE2/3/4 */
(function () {
  var TAG = 'cazotti-clothing-bundle';
  var TIERS = [
    { qty: 4, code: 'BUNDLE4' },
    { qty: 3, code: 'BUNDLE3' },
    { qty: 2, code: 'BUNDLE2' }
  ];
  var applying = false;
  var lastCode = '';
  var tagCache = {};

  function cookieCode() {
    var m = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
    return m ? decodeURIComponent(m[1]).toUpperCase() : '';
  }

  async function bundleQty(cart) {
    var handles = [];
    (cart.items || []).forEach(function (it) {
      if (it.handle && handles.indexOf(it.handle) === -1) handles.push(it.handle);
    });
    await Promise.all(handles.map(async function (h) {
      if (tagCache[h]) return;
      try {
        var res = await fetch('/products/' + h + '.js', { credentials: 'same-origin' });
        if (!res.ok) { tagCache[h] = []; return; }
        var p = await res.json();
        tagCache[h] = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      } catch (e) {
        tagCache[h] = [];
      }
    }));
    var n = 0;
    (cart.items || []).forEach(function (it) {
      var tags = tagCache[it.handle] || [];
      if (tags.indexOf(TAG) !== -1) n += it.quantity;
    });
    return n;
  }

  async function applyBest() {
    if (applying) return;
    try {
      var res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      var cart = await res.json();
      var qty = await bundleQty(cart);
      var tier = null;
      for (var i = 0; i < TIERS.length; i++) {
        if (qty >= TIERS[i].qty) { tier = TIERS[i]; break; }
      }
      if (!tier) return;
      var current = cookieCode();
      if (current === tier.code || lastCode === tier.code) return;
      applying = true;
      lastCode = tier.code;
      await fetch('/discount/' + encodeURIComponent(tier.code), {
        credentials: 'same-origin',
        redirect: 'manual'
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {
    } finally {
      applying = false;
    }
  }

  function boot() {
    applyBest();
    document.addEventListener('cart:change', function () { setTimeout(applyBest, 400); });
    document.addEventListener('product-added-to-cart', function () { setTimeout(applyBest, 500); });
    var _fetch = window.fetch;
    if (typeof _fetch === 'function') {
      window.fetch = function () {
        var args = arguments;
        return _fetch.apply(this, args).then(function (r) {
          try {
            var url = String((args[0] && args[0].url) || args[0] || '');
            if (/\/cart\/(add|change|update|clear)/.test(url)) setTimeout(applyBest, 700);
          } catch (e) {}
          return r;
        });
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
